import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { ServerService } from "../server.service";
@Component({
  selector: 'app-modulo-director',
  templateUrl: './modulo-director.component.html',
  styleUrls: ['./modulo-director.component.css']
})
export class ModuloDirectorComponent implements OnInit {
  listaencuesta:any[]
  constructor(private router:Router,private server: ServerService) { }

  ngOnInit(): void {
      this.server.getEncuestasprofesores().subscribe((res:any)=>{
      this.listaencuesta= res;
   })

  }

  logout(): void{
    localStorage.removeItem("rol")
    this.router.navigateByUrl('/login');
  }

  redireccionar():void{

    this.router.navigateByUrl('/crear-encuesta');
  }

}
